import React from "react";
import AirDropHero from "./hero";
import TaskCenter from "./taskCenter";
import Unlocking from "./unlocking";

export default function Airdrop() {
  return (
    <div>
      <AirDropHero />
      <TaskCenter />
      <Unlocking />
    </div>
  );
}
